import { Typography, styled } from "@mui/material";

const OperationTypographyLabelText = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(1),
    fontWeight: 400,
    fontSize: "1rem",
}));

export default OperationTypographyLabelText